import {
    useState,
    useCallback
} from 'react';
import {
    Container,
    Content,
    InfoDocument,
    PreviewPDF,
    LoadSpin,
    IconFile,
    Body
} from './styled';
import VisibilitySensor from 'react-visibility-sensor';
import { Footer } from '../../components';
import { getMidia } from '../../../../service/serviceChat/chatService';
import { MdOutlineDownloading } from 'react-icons/md';
import { FaFile } from "react-icons/fa6";


export function Document(props) {


    const { message } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [url, setUrl] = useState('');
    const [automaticLoading, setAutomaticLoading] = useState(true);


    const searchDocument = useCallback(async (message) => {
        const res = await getMidia(message?.id_document ? message?.id_document : message?.id);
        return res.url
    }, [])
    const onSearchDocument = async (isVisible) => {
        if (!isVisible || url) return;
        if (message?.extension !== '.pdf') {
            setIsLoading(false);
            setAutomaticLoading(false);
            return
        }
        setIsLoading(true);
        const documentURL = await searchDocument(message);
        setUrl(documentURL)
        setIsLoading(false);
        setAutomaticLoading(false);
    }

    async function handleDownload() {
        setIsLoading(true);
        const documentURL = url ? url : await searchDocument(message);
        function download(documentURL, filename) {
            fetch(documentURL)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                    setIsLoading(false);
                })
                .catch(console.error);
        }
        download(documentURL, `${message?.filename}`)
    }
    function handleExternalLink() {
        if (!url && message?.extension !== '.pdf') return;
        window.open(url)
    }

    const GenerationIcon = () => {
        const extension = message?.extension.replace(".", "").toUpperCase();
        return (
            <IconFile>
                <div className={(extension === 'PDF' && 'pdf')}>
                    <FaFile
                        className='icon--file'
                        fontSize={'3rem'}
                    />
                    {(extension.length <= 3) &&
                        <span className={'fsTS'}>
                            {extension}
                        </span>
                    }
                </div>
            </IconFile>
        )
    }

    return (
        <Container
            isUserSystem={message?.user_system ? true : false}
        >
            {(automaticLoading)
                ? <VisibilitySensor
                    onChange={
                        (isVisible) => {
                            onSearchDocument(isVisible)
                        }
                    }>
                    <div className='skeleton--box'>
                        <span className='skeleton'></span>
                        <div className='description--'>
                            <div className='filename'>
                                {message?.filename}
                            </div>
                        </div>
                    </div>
                </VisibilitySensor>
                : <>
                    {(message?.extension === '.pdf' && url) &&
                        <PreviewPDF>
                            <object
                                data={url}
                                type='application/pdf'
                                width='100%'
                                height='500px'
                                style={{ overflow: 'hidden' }}
                            >
                                <div className='error-'>
                                    <p>
                                        {`
                                            Não foi possível carregar o arquivo,
                                            clique
                                        `}
                                        <br />
                                        <a href={url}>aqui</a>
                                        {` para abrir o visualizar.`}
                                    </p>
                                </div>
                            </object>
                            <span
                                className='linkExternal'
                                onClick={() => handleExternalLink()}
                            />
                        </PreviewPDF>
                    }
                    <Content>
                        <InfoDocument>
                            <GenerationIcon />
                            <div>
                                {message?.filename}
                            </div>
                            <div>
                                <span className='Down'>
                                    {(!isLoading)
                                        ? <MdOutlineDownloading
                                            onClick={
                                                () => handleDownload()
                                            }
                                        />
                                        : <LoadSpin />
                                    }
                                </span>
                            </div>
                        </InfoDocument>
                        {(message?.body) &&
                            <Body>
                                {message?.body}
                            </Body>
                        }
                    </Content>
                </>
            }
            <div className='footer-styled'>
                <Footer message={message} />
            </div>
        </Container>
    )
}